<template>
<div class="row sharing-exp-pass">
  <div class="col-md-12">
    <form @submit.prevent="submitForm($event)">
      <div class="form-group" v-if="!has_password && !edit_mode">
        <a href="#" @click="addPassword()">{{ $t('share_invite.add_pass') }}</a>
      </div>
      <div class="form-group" v-if="has_password || edit_mode">
        <div v-if="!edit_mode">
          {{ $t('share_invite.pass_set') }} ( <a href="#" @click.prevent="edit_mode = true">{{ $t('share_invite.change') }}</a> )
        </div>
        <div v-else>
          <input type="password" name="folder[password]" id="folder-password" class="set-password form-control" v-model="password" v-focus :placeholder="placeholder">
          <button type="submit" class="btn btn-outline-primary btn-sm">{{ $t('share_invite.save') }}</button>
        </div>
      </div>
    </form>
  </div>
</div>
</template>

<script>
export default {
  props: ['folder_id', 'has_password', 'folder_ids'],
  data() {
    return {
      password: '',
      edit_mode: false,
      placeholder: this.$t('share_invite.type_pass')
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    addPassword (){
      this.edit_mode = true
    },
    submitForm (e) {
      let params = new FormData(e.target)

      if (params.get('folder[password]').length == 0) {
        this.$toastr.alert(this.$t('share_invite.pls_provide_pass'))
        return
      }

      this.password = ''

      this.axios.patch('/folders/' + this.$props.folder_id + '/settings/', params).then(() => {
        this.$emit('reload-settings')
        this.edit_mode = false
        this.$toastr.success(this.$t('shared.updated_successfully'))
        this.store.sendMetrics({name: 'add_folder_share_password', params: this.$route.params, path: this.$route.fullPath})
      })
    }
  }
}
</script>
